import { useState, useEffect } from 'react'
import Router from 'next/router'

type npStateType = {
    isRouteChanging: boolean
    loadingKey: number
}

type useRouteProgressStateType = () => npStateType

/**
 * Estado de la barra de progreso de navegación.
 *
 * Se suscribe al singleton `Router.events` con deps `[]`: depender de
 * `router.events` desde `useRouter()` puede cambiar de identidad en cada
 * render (Next 16) y re-montar el effect en loop → "Maximum update depth".
 */
export const useRouteProgressState: useRouteProgressStateType = () => {
    const [npState, setNpState] = useState<npStateType>({
        isRouteChanging: false,
        loadingKey: 0
    })

    useEffect(() => {
        const handleRouteChangeStart = () => {
            setNpState((prevState) => ({
                isRouteChanging: true,
                loadingKey: prevState.loadingKey ^ 1
            }))
        }

        const handleRouteChangeEnd = () => {
            setNpState((prevState) =>
                prevState.isRouteChanging
                    ? { ...prevState, isRouteChanging: false }
                    : prevState
            )
        }

        Router.events.on('routeChangeStart', handleRouteChangeStart)
        Router.events.on('routeChangeComplete', handleRouteChangeEnd)
        Router.events.on('routeChangeError', handleRouteChangeEnd)

        return () => {
            Router.events.off('routeChangeStart', handleRouteChangeStart)
            Router.events.off('routeChangeComplete', handleRouteChangeEnd)
            Router.events.off('routeChangeError', handleRouteChangeEnd)
        }
    }, [])

    return npState
}
